"use client";

import { useEffect, useRef } from "react";
import { useMyLinkProfileQuery, useUpdateProfileMutation } from "@/modules/creator/services/creatorClient";

export function TimezoneSync() {
    const { data: profile } = useMyLinkProfileQuery();
    const { mutate, isPending } = useUpdateProfileMutation();
    const hasSyncedRef = useRef(false);

    useEffect(() => {
        if (!profile || isPending || hasSyncedRef.current) return;

        try {
            const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const storedTimezone = profile.timezone;

            if (browserTimezone && browserTimezone !== storedTimezone) {
                console.info("Syncing timezone with backend", {
                    browserTimezone,
                    storedTimezone,
                });

                hasSyncedRef.current = true;
                mutate({
                    timezone: browserTimezone,
                });
            }
        } catch (error) {
            console.error("Failed to sync timezone", { error });
        }
    }, [profile, mutate, isPending]);

    return null;
}
